(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/objects/scBlock/types/team/templates/activity', '<section class="team-block_activity" data-ng-class="{publicSection: public}">\n' + '  <div\n' + '    data-sc-feed="team.current"\n' + '    data-type="fundraising-team"\n' + '    data-allow-commenting="block.allowCommenting"\n' + '    data-demo="fundraiser.isDemo"\n' + '    data-block="block"\n' + '    data-theme="theme"\n' + '    data-demo="demo"\n' + '  ></div>\n' + '</section>\n' + '');
}]);
})();